import React, { useEffect } from 'react';
import Portal from './Portal';

export default function ModalShell({ visible, onClose, stacked = false, width = 720, height, children }) {
  useEffect(() => {
    if (!visible) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <Portal>
      <div className={`seg-scrim${stacked ? ' stacked' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
        <div
          className="modal"
          style={{
            width,
            maxWidth: '94vw',
            ...(height ? { height, maxHeight: '94vh' } : { maxHeight: '92vh' }),
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </div>
      </div>
    </Portal>
  );
}
